import { useContentBannerSearch } from 'domains/banners/api/searchBanner.hooks'
import { useBannersListColumns } from 'domains/banners/utils/useQueryBannerListColumns.hooks'
import { bannersAdminRoutingConfig } from 'domains/banners/utils/bannersRoutingConfig'

export const useBannerList = () => {
  const columns = useBannersListColumns(bannersAdminRoutingConfig)

  const { apiResult, apiSuccess, apiLoading, apiError, banners, searchBanners } =
    useContentBannerSearch()

  return {
    apiResult,
    apiSuccess,
    apiLoading,
    apiError,
    banners,
    columns,
    searchBanners,
  }
}

export type ListBannerBehaviour = ReturnType<typeof useBannerList>
